module.exports = __webpack_public_path__ + "img/mail.4e633ad7.svg";